<template>



	<b-dropdown 
	size="sm"
	variant="outline-secondary"
	no-caret
	menu-class="bg-lidght border border-secondary" 
	class="profile-btn p-0 border-0"
	xdropleft=""
	xoffset="25"
	right 
	toggle-class="rounded-circle d-flex p-0 border-0"
	>
		<template v-slot:button-content>
			<icon name="mdi.account-circle" class="profile-icon m-auto"/>
		</template>

		<b-dropdown-group style="">
			
			<div class="pt-0 pb-2 m-0 border-bottom d-flex">
				<span class="username text-muted m-auto">{{$store.getters.email}}</span>
			</div>

		</b-dropdown-group>

		<b-dropdown-group>
			<b-dropdown-item :to="{name:'Logout'}" style="font-size:0.8em">
				<icon name="sign-out"/> Log Out
			</b-dropdown-item>
		</b-dropdown-group>

	</b-dropdown>


</template>

<script>
	export default {

	}
</script>

<style lang="scss" scoped>

	$bg-color:rgb(32, 32, 32);

	$bg-color2:rgb(36, 36, 36);


	.username{
		font-size: 0.75em;
	}


	.profile-btn{
		// z-index:2000;
		width:3em !important;
		height:3em !important;
	}


	.profile-icon{
		font-size:2.2em;
		margin:0;
	}



	.user-area{
		// min-width:3.5em;
		display:flex;
	}

	

</style>